import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence, indexedDBLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Dynamic authDomain based on current hostname
const getAuthDomain = () => {
  if (typeof window === 'undefined') {
    return "edumi-4dfbe.firebaseapp.com";
  }
  
  const hostname = window.location.hostname;

  // หมายเหตุ: ต้องใช้ authDomain ที่ลงทะเบียนเป็น OAuth redirect URI ไว้แล้ว
  // (edumi-4dfbe.firebaseapp.com) ไม่งั้น Google sign-in จะขึ้น "The requested action is invalid"
  // saledi.web.app / คอร์สดี.com ฯลฯ ไม่ได้อยู่ใน authorized redirect URIs ของ OAuth client
  // จึงต้องใช้ default เสมอ (popup เปิดผ่าน firebaseapp.com — ใช้ได้ทุก host ผ่าน COOP same-origin-allow-popups)
  void hostname;

  // Default to Firebase authDomain (works for saledi.web.app, custom domains incl. คอร์สดี.com)
  return "edumi-4dfbe.firebaseapp.com";
};

const firebaseConfig = {
  apiKey: "AIzaSyAPUJpL412im5IiSK6hb18aTAdTxUhAYas",
  authDomain: getAuthDomain(),
  projectId: "edumi-4dfbe",
  storageBucket: "edumi-4dfbe.firebasestorage.app",
  messagingSenderId: "191275868600",
  appId: "1:191275868600:web:c1a769b078007d825fef4d",
};

const app = initializeApp(firebaseConfig);

// App Check ต้อง activate ก่อนเรียก Firestore/Storage/Functions ใดๆ เพื่อไม่ให้ชนกับ request แรก
// ห่อ try/catch ไว้: ถ้า attestation ใช้ไม่ได้ (เช่นโดเมนไม่ได้ลงทะเบียนใน reCAPTCHA) เว็บต้องทำงานต่อได้ปกติ
try {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LclbpgtAAAAAGn_DPS9A3pHIKeHQFOD6_xLMscc'),
    isTokenAutoRefreshEnabled: true,
  });
} catch (error) {
  console.warn('[Firebase] App Check unavailable, continuing without it', error);
}

export { app };
export const auth = getAuth(app);

// Set auth persistence to LOCAL for both desktop and mobile
// This ensures users stay logged in even after closing the browser
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('[Firebase] Auth persistence set to LOCAL - users will stay logged in');
  })
  .catch((error) => {
    console.error('[Firebase] Failed to set auth persistence:', error);
  });

export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);
